import React from 'react';
import { useSelector } from 'react-redux';
import { TemplateState, } from '@debbie/common/dist/templates/index.js';
import { selectTemplates } from '@debbie/cortex/dist/templates/selectors.js';
import { SearchInput } from '../../index.js';
const TemplateSearch = (props) => {
    const templates = useSelector(selectTemplates);
    const lang = useSelector((s) => s.lang);
    const searchAllTemplates = (searchPhrase) => {
        return Object.entries((templates
            ? templates.filter((template) => {
                const containsSearchPhrase = searchPhrase.length === 0 ||
                    template.name
                        .toLowerCase()
                        .indexOf(searchPhrase.toLowerCase()) !== -1;
                const isCorrectType = template.type === props.templateType &&
                    template.state === TemplateState.PUBLISHED;
                return containsSearchPhrase && isCorrectType;
            })
            : []).reduce((acc, template) => {
            acc[template.templateId] = (acc[template.templateId] || []).concat(template);
            return acc;
        }, {})).map(([templateId, _templates]) => ({
            key: templateId,
            heading: _templates[0]?.name,
            returnData: { templateId, templates: _templates },
        }));
    };
    return (React.createElement(SearchInput, { onSelect: (_templates) => {
            props.onChange(_templates);
        }, static: props.selectedTemplate &&
            props.selectedTemplate.templates[0] &&
            props.selectedTemplate.templates[0].name, onRemoveStatic: () => {
            props.onChange(null);
        }, searchDelay: 0, forceOpen: true, searchAll: searchAllTemplates, placeholder: lang.interactions.selectTemplate }));
};
export default TemplateSearch;
//# sourceMappingURL=TemplateSearch.js.map